export const CAREER_CENTER_QUERY_KEY = "career-center"
export const CAREER_CENTER_MODULES_QUERY_KEY = "career-center-modules"
export const CAREER_CENTER_AUTOCOMPLETE_QUERY_KEY = "career-center-autocomplete"
export const CAREER_CENTER_INFOS_QUERY_KEY = "career-center-infos"
export const SCHOOL_CONFIGURATION_QUERY_KEY = "school-configuration-infos"
export const SCHOOL_AUTOCOMPLETE_QUERY_KEY = "school-autocomplete"
export const SCHOOL_COMMUNICATION_STATUS_QUERY_KEY = "school-communication-status"

export const QUERY_CACHE_TIME = 30 * 60 * 1000 // 30 min
export const QUERY_STALE_TIME = 15 * 60 * 1000 // 15 min
